module.exports = __webpack_public_path__ + "img/balearic-islands.b1bb6400.svg";